import { render, staticRenderFns } from "./TabelaAdicionarPapel.vue?vue&type=template&id=7a05f8c4"
import script from "./TabelaAdicionarPapel.vue?vue&type=script&lang=js"
export * from "./TabelaAdicionarPapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports